import {
  ProductionCycleDepartmentProductionParams,
  SectionProductionCycleProductionParams
} from '§M/types/productionparams.type'
import { defaultProductionParametersFor } from '§U/productionplan/parameters'

/** The stocking values a new production cycle starts from (the column defaults) */
export const defaultProductionCycleProductionParameters: () => SectionProductionCycleProductionParams = () => {
  return {
    fish_number_start: 100_000,
    fish_weight_start: 1,
    fish_weight_end: 0
  }
}

/**
 * The values a new cycle node starts from: the production parameters (the
 * hatchery degree days among them) come from the domain defaults, and a new
 * growth node feeds for a number of days
 */
export const defaultProductionCycleDepartmentProductionParameters: () => ProductionCycleDepartmentProductionParams =
  () => {
    return {
      ...defaultProductionParametersFor('productioncycledepartment'),
      // Schedule inputs
      fish_weight_start: 0,
      fish_number_start: 0,
      fish_days_of_starvation: 0,
      // End criterion
      fish_weight_end: null,
      fish_days_of_feeding: 80
    }
  }

export const defaultColors = [
  '#00A991',
  '#a984f4',
  '#ebf99e',
  '#76bdc8',
  '#c5d8d9',
  '#e7e1cf',
  '#ebdde4',
  '#b14a72',
  '#5841b6',
  '#bcfca5',
  '#b4ead6',
  '#c43548',
  '#e76772',
  '#ecf284',
  '#f9e3ce',
  '#618d84',
  '#617f60',
  '#f1cfb2',
  '#f55055',
  '#a298fa',
  '#6a4287',
  '#e6d7ea'
]

export const defaultTankShapeThickness = 0.1
export const defaultDepartmentShapeThickness = 0
